const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Discover24 = function Discover24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.83 12.826s-6.512 4.54-18.438 6.571h18.437v-6.571z",
      fill: "#E7792B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.913 4.4 2 4.404v15.165h24L25.998 4.4h-.085zm-.086.173v14.823H2.174L2.173 4.573h23.654z",
      fill: "#1A1918",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.098 9.042h-.993v3.43h.99c.525 0 .905-.122 1.238-.395a1.714 1.714 0 0 0 .63-1.317c0-1.013-.765-1.718-1.864-1.718zm.792 2.577c-.213.19-.49.273-.927.273H3.78V9.624h.182c.438 0 .703.077.927.277.234.206.375.526.375.855 0 .329-.14.658-.375.864zm1.384-2.577h.678v3.43h-.678v-3.43zm2.335 1.316c-.407-.148-.526-.247-.526-.432 0-.216.212-.38.505-.38.203 0 .369.082.545.278l.355-.459a1.53 1.53 0 0 0-1.02-.38c-.615 0-1.084.422-1.084.984 0 .472.218.714.854.94.265.092.402.154.47.196a.41.41 0 0 1 .202.354c0 .279-.224.484-.525.484a.803.803 0 0 1-.74-.457l-.438.416c.313.453.687.653 1.202.653.705 0 1.198-.462 1.198-1.126 0-.546-.228-.792-.999-1.07h.001zm1.212.402c0 1.008.802 1.79 1.833 1.79.291 0 .542-.056.85-.2v-.787c-.271.267-.511.375-.819.375-.681 0-1.165-.489-1.165-1.183 0-.659.499-1.179 1.134-1.179.324 0 .568.114.85.386v-.787a1.747 1.747 0 0 0-.835-.211c-1.025 0-1.848.798-1.848 1.796zm8.054.586-.927-2.304h-.74l1.475 3.52h.364l1.5-3.52h-.734l-.939 2.304h.001zm1.979 1.127h1.92v-.581h-1.243v-.926h1.198v-.581H20.53v-.762h1.245v-.581h-1.921v3.43zm4.603-2.419c0-.641-.448-1.012-1.23-1.012h-1.004v3.43h.677v-1.378h.089l.937 1.379h.834l-1.094-1.445c.51-.103.791-.448.791-.974zm-1.36.568H22.9v-1.04h.209c.421 0 .65.175.65.508 0 .346-.229.532-.661.532z",
      fill: "#1A1918",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M14.555 12.584c1.01 0 1.83-.812 1.83-1.813 0-1.002-.82-1.814-1.83-1.814-1.01 0-1.83.812-1.83 1.814 0 1.001.82 1.813 1.83 1.813z",
      fill: "#E7792B",
    })
  );
};
Discover24.defaultProps = {
  width: "28",
  height: "24",
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Discover32 = function Discover32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M31 14.5S22.744 20.318 7 23h21a3 3 0 0 0 3-3v-5.5z",
      fill: "#E7792B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M3.311 9.506H2v4.53h1.306c.694 0 1.196-.162 1.636-.523a2.262 2.262 0 0 0 .832-1.739c0-1.337-1.01-2.268-2.462-2.268zm1.046 3.402c-.282.252-.646.36-1.225.36h-.239v-2.994h.24c.578 0 .928.103 1.224.367.31.272.495.693.495 1.128 0 .434-.186.868-.495 1.14zm1.827-3.402h.895v4.53h-.895v-4.53zm3.083 1.738c-.538-.196-.695-.326-.695-.57 0-.285.28-.503.666-.503.268 0 .487.11.72.368l.469-.606a2.02 2.02 0 0 0-1.348-.502c-.811 0-1.43.557-1.43 1.299 0 .623.288.942 1.128 1.241.35.122.53.203.619.258a.54.54 0 0 1 .268.469c0 .367-.296.638-.694.638-.427 0-.77-.21-.977-.603l-.577.55c.412.597.907.862 1.587.862.93 0 1.581-.61 1.581-1.488 0-.72-.301-1.045-1.318-1.413zm1.6.53c0 1.332 1.058 2.364 2.42 2.364.384 0 .715-.075 1.121-.264v-1.04c-.358.353-.674.496-1.08.496-.9 0-1.54-.646-1.54-1.562 0-.87.66-1.556 1.499-1.556.427 0 .75.15 1.121.51v-1.04c-.393-.197-.716-.279-1.101-.279-1.354 0-2.44 1.054-2.44 2.371zm10.632.774-1.223-3.042h-.977l1.946 4.646h.481l1.98-4.646h-.968l-1.24 3.042h.001zm2.613 1.488h2.535v-.767h-1.641v-1.223h1.581v-.767h-1.582v-1.006h1.642v-.767h-2.535v4.53zm6.077-3.193c0-.848-.591-1.337-1.623-1.337H27.24v4.53h.894v-1.82h.116l1.237 1.82h1.101l-1.444-1.908c.674-.136 1.045-.591 1.045-1.285zm-1.795.749h-.26v-1.373h.275c.556 0 .86.23.86.672 0 .455-.304.7-.875.7z",
      fill: "#1A1918",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M17.116 14.182a2.405 2.405 0 0 0 2.416-2.393 2.405 2.405 0 0 0-2.416-2.394 2.405 2.405 0 0 0-2.415 2.394 2.405 2.405 0 0 0 2.415 2.393z",
      fill: "#E7792B",
    })
  );
};
Discover32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Discover24,
  32: Discover32,
};
export function Discover(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Discover' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
